import { connect } from "react-redux"
import CallToActionWidget from "QuorumGrassroots/widgets/CallToAction/components/index"
import { fullWidthWidgetConnection } from "QuorumGrassroots/widgets/selectors"

export default connect(fullWidthWidgetConnection, null)(CallToActionWidget)
